/* eslint-disable import/no-extraneous-dependencies */
import { requirejs, originalRequire, define } from 'requirejs';
import globalApps from '@bingads-webui-clientcenter/global-apps';

/**
 * This file is for bootstrapping legacy requirejs
 * In legacy js code and server side cshtml we require many
 * libs which may not be included in bingads-lib(-ext)
 *
 * the ultimate objective is to make the bingads-lib thinner by removing most libs
 */

let libs = {};

let skipDefaultLoad = {};

const requireLoadHistory = {};

export const shimRequireLoad = (appName) => {
  // Shim the RJS load function to inject the webpack module.
  // This gets called when RJS cannot find the module in any of its bundles.
  const realLoadFn = originalRequire.load;
  originalRequire.load = function loader(context, moduleName, url) {
    if (!moduleName || !libs[moduleName]) {
      if (!requireLoadHistory[moduleName]) {
        if (globalApps.logging && globalApps.logging.trace) {
          requireLoadHistory[moduleName] = true;
          globalApps.logging.trace(`WebpackMissingModule-${appName}`, moduleName);
        }
      }
      realLoadFn(context, moduleName, url);
      return;
    }

    const libraryLoader = libs[moduleName];
    libraryLoader().then((libExports) => {
      const contents = (skipDefaultLoad[moduleName] || !libExports.default)
        ? libExports
        : libExports.default;

      define(moduleName, [], () => contents);
      context.completeLoad(moduleName);
    });
  };
};

export const addLibs = (newLibs = {}, newSkipDefaultLoad = {}) => {
  Object.keys(newLibs).forEach(name => requirejs.undef(name));
  libs = {
    ...libs,
    ...newLibs,
  };

  skipDefaultLoad = {
    ...skipDefaultLoad,
    ...newSkipDefaultLoad,
  };
};
